<div
    class="sidebar offcanvas offcanvas-start"
    data-bs-scroll="true"
    data-bs-backdrop="false"
    tabindex="-1"
    id="offcanvasScrolling"
    aria-labelledby="offcanvasScrollingLabel"
>
    <div class="text-center d-none d-lg-block pb-4">
        <a routerLink="/"><img class="logo-auth" src="assets/images/logo2.svg" alt="logo"/></a>
    </div>

    <button
        type="button"
        class="btn-close d-lg-none"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
    ></button>

    <div class="accordion" id="accordionExample">
        <div class="accordion-item">
            <h2 class="accordion-header">
                @if (Permissions.VIEW_ADMIN_DASHBOARD | hasPermission) {
                    <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapse4"
                        aria-expanded="false"
                        aria-controls="collapse4"
                        routerLink="/cdss/admin-dashboard" routerLinkActive="active"
                    >

                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.0059 3C13.6768 3.0001 15.0225 4.34641 15.0225 5.99512C15.0222 7.64361 13.6767 8.98916 12.0059 8.98926C10.335 8.98926 8.98952 7.64367 8.98926 5.99512C8.98926 4.34635 10.3348 3 12.0059 3Z" stroke="currentColor" stroke-width="2"/>
                            <path d="M12.001 12.3472H12.0137C13.998 12.3302 15.9331 12.9625 17.5195 14.146L17.5303 14.1548L17.541 14.1616C17.8814 14.4017 18.2006 14.6705 18.4951 14.9644L18.5 14.9692C19.7389 16.1907 20.5963 17.7407 20.9727 19.4331H20.9736C21.0117 19.6171 21.0084 19.8072 20.9639 19.9897C20.9192 20.1724 20.8342 20.3439 20.7148 20.4907L20.7119 20.4937C20.5852 20.6511 20.424 20.779 20.2402 20.8667C20.0565 20.9544 19.8547 20.9996 19.6504 20.9995H4.34863C4.14492 21.0021 3.94321 20.9596 3.75879 20.8745C3.62039 20.8107 3.4944 20.7243 3.38574 20.6196L3.2832 20.5093C3.16398 20.3619 3.07931 20.1905 3.03516 20.0073C2.99076 19.823 2.98862 19.6311 3.02832 19.4458C3.40292 17.7497 4.26143 16.1963 5.50195 14.9722C7.23401 13.2793 9.57031 12.3348 12.001 12.3472Z" fill="currentColor" stroke="currentColor" stroke-width="2"/>
                        </svg>
                        <span class="nav-label">Admin</span>
                    </button>
                }

                @if (Permissions.VIEW_CONTRACTS | hasPermission) {
                    <div ngbDropdown placement="end-top" container="body" class="d-block">
                        <button
                            class="accordion-button collapsed w-100"
                            type="button"
                            ngbDropdownToggle
                            aria-label="Contracts"
                            [class.active]="isContractsActive"
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5Z" stroke="#718998" stroke-width="2" stroke-linejoin="round"/>
                                <path d="M14 3v5h5M9 13h6M9 17h6" stroke="#718998" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                        <div ngbDropdownMenu>
                            <a ngbDropdownItem [routerLink]="contractsListRoute">{{ (Permissions.CREATE_CONTRACT | hasPermission) ? 'All contracts' : 'My contracts' }}</a>
                            @if (Permissions.CREATE_CONTRACT | hasPermission) {
                                <a ngbDropdownItem [routerLink]="contractNewRoute">+ New contract</a>
                            }
                        </div>
                    </div>
                }

                @if (Permissions.VIEW_ORGANISATIONS | hasPermission) {
                    <div ngbDropdown placement="end-top" container="body" class="d-block">
                        <button
                            class="accordion-button collapsed w-100"
                            type="button"
                            ngbDropdownToggle
                            aria-label="Organisations"
                            [class.active]="isOrganisationsActive"
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                <path d="M4 21V5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v16M14 10h5a1 1 0 0 1 1 1v10M3 21h18M8 8h2M8 12h2M8 16h2" stroke="#718998" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                        <div ngbDropdownMenu>
                            <a ngbDropdownItem [routerLink]="organisationsListRoute">{{ (Permissions.CREATE_ORGANISATION | hasPermission) ? 'All organisations' : 'My organisations' }}</a>
                            @if (Permissions.CREATE_ORGANISATION | hasPermission) {
                                <a ngbDropdownItem [routerLink]="organisationNewRoute">+ New organisation</a>
                            }
                        </div>
                    </div>
                }

                <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapse1"
                    aria-expanded="false"
                    aria-controls="collapse1"
                    routerLink="/cdss/dashboard" routerLinkActive="active"
                >
                    <i class="bi bi-grid-1x2-fill"></i>
                    <span class="nav-label">Dashboard</span>
                </button>

                <!-- UNIVAPLAT-2600 (Epic UNIVAPLAT-2588): "my calendar" / Sessions entry intentionally
                     deactivated (CometChat deprecation) — cdss/pages/appointments/** kept in the repo
                     for possible future reactivation; the /cdss/sessions route is unreachable. -->

                <div ngbDropdown placement="end-top" container="body" class="d-block">
                    <button
                        class="accordion-button collapsed w-100"
                        type="button"
                        ngbDropdownToggle
                        [class.active]="isRegistrationActive"
                    >
                        <i class="bi bi-plus-circle-fill"></i>
                        <span class="nav-label">New patient</span>
                    </button>
                    <div ngbDropdownMenu>
                        <a ngbDropdownItem routerLink="/cdss/patient-registration">New patient</a>
                        <a ngbDropdownItem routerLink="/cdss/draft-patients">Draft patients</a>
                    </div>
                </div>
            </h2>
        </div>
    </div>
</div>
